import { Box, Typography } from '@mui/material';

import { PlanDemo } from 'common/components/PlanDemo';

interface IProps {
    description?: string;
    hideButtons?: boolean;
    title?: string;
}

export const DrawerUpgradeSection = ({
    description,
    hideButtons,
    title,
}: IProps) => (
    <Box sx={{ mb: 4 }}>
        <Typography variant="h3">{title}</Typography>

        <Box sx={{ mt: 2 }}>
            <Typography>{description}</Typography>
        </Box>

        {!hideButtons && <PlanDemo />}
    </Box>
);
